import {mdiClose} from "@mdi/js";
import Icon from "@mdi/react";
import React, {useEffect, useRef, useState} from "react";

// Inlines Styles für Struktur
const closeButtonStyle = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '24px',
};


const OrderPreview = ({ order, show, onClose, resizeRef, onResize }) => {
  if (!show) {
    return null;
  }

  // Ref & State zur Nachverfolgung der Größe
  const mailViewRef = useRef(null);
  const [width, setWidth] = useState(null); // Default-Breite
  const [maxWidth, setMaxWidth] = useState(window.innerWidth); // Fallback
  const [isResizing, setIsResizing] = useState(false); // Status für Resizing
  const overlayRef = useRef(null); // Ref für transparentes Overlay

  useEffect(() => {
    if (resizeRef.current) {
      const parent = resizeRef.current.parentElement; // Nächstgelegener Container
      if (parent) {
        const parentRect = parent.getBoundingClientRect(); // Größe des UI-Containers
        setMaxWidth(parentRect.width); // Dynamische Maximalbreite setzen
      }
    }
  }, []);

  const handleMouseDown = (e) => {
    e.preventDefault();

    const startX = e.clientX; // Anfangsposition der Maus
    const startWidth = resizeRef.current.offsetWidth;

    // Overlay aktivieren
    setIsResizing(true);

    const handleMouseMove = (e) => {
      const delta = e.clientX - startX;
      let newWidth = startWidth + delta;

      // Dynamische Maximalbreite verwenden
      if (newWidth < 100) {
        newWidth = 100; // Mindestbreite
      } else if (newWidth > maxWidth) {
        newWidth = maxWidth; // Berechnete Maximalbreite
      }

      onResize(newWidth); // Breite aktualisieren
    };

    const handleMouseUp = () => {
      // Listener entfernen
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);

      // Overlay deaktivieren
      setIsResizing(false);
    };

    // Listener hinzufügen
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  return (
    <div
      className="h-100 d-flex flex-row flex-grow-1"
      id="mail-view"
      ref={mailViewRef}
      style={{ position: "relative" }}
    >
      {/* Resizer */}
      <div
        className="mail-view-resizer"
        onMouseDown={handleMouseDown}
        style={{
          width: "3px",
          background: "rgba(34,34,34,0.6)",
          cursor: "ew-resize",
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          height: "100%",
        }}
      />

      {/* Close-Button */}
      <div className={"mail-view-close"}>
        <button
          onClick={onClose}
          style={{ background: "none", border: "none", cursor: "pointer" }}
          aria-label="Close Event"
        >
          <Icon color={"rgb(110,110,110)"} path={mdiClose} size={1} />
        </button>
      </div>

      {/* Overlay während des Resizings */}
      {isResizing && (
        <div
          ref={overlayRef}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 9999,
            cursor: "ew-resize",
            background: "transparent", // Unsichtbare Schicht für Maus-Events
          }}
        />
      )}

      {/* Iframe */}
      <iframe
        className="email-body w-100 h-100"
        srcDoc={order} // Inhalt von "order" als HTML im iFrame gerendert
        sandbox="allow-same-origin allow-scripts"
      />
    </div>
  );
};
export default OrderPreview;
